<template>
	<div class="seller">
		<myheader ref="header"></myheader>
		<mynav notsearch></mynav>
		<div class="main">
			<div class="navmenu">
				<el-menu router :default-active="menuActive" class="el-menu-vertical-demo" @select="menuSelect" :collapse="collapse">
					<el-menu-item index="/seller/home">
						<i class="el-icon-house"></i>
						<span slot="title">首页</span>
					</el-menu-item>
					<el-menu-item index="/seller/notice">
						<i class="el-icon-chat-dot-round"></i>
						<span slot="title">公告管理</span>
					</el-menu-item>
					<el-submenu index="/seller/management">
						<template slot="title">
							<i class="el-icon-setting"></i>
							<span>渠道管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/seller/management/channel">渠道维护</el-menu-item>
							<el-menu-item index="/seller/management/discount">折扣维护</el-menu-item>
							<el-menu-item index="/seller/management/shippingCost">运费维护</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<el-submenu index="/seller/order">
						<template slot="title">
							<i class="el-icon-document"></i>
							<span>订单管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/seller/order/order">订单管理</el-menu-item>
							<el-menu-item index="/seller/order/service">售后管理</el-menu-item>
							<el-menu-item index="/seller/order/work">工单管理</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<el-submenu index="/seller/moneys">
						<template slot="title">
							<i class="el-icon-coin"></i>
							<span>财务管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/seller/moneys/moneylist">账户明细</el-menu-item>
							<el-menu-item index="/seller/moneys/prepay">账单管理</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<el-submenu index="/seller/erp" v-if="appdata.myinfo.is_jst == 1">
						<template slot="title">
							<i class="el-icon-paperclip"></i>
							<span>ERP管理</span>
						</template>
						<el-menu-item-group>
							<el-submenu index="/seller/erp/jushuitan">
								<template slot="title">聚水潭</template>
								<el-menu-item index="/seller/erp/jushuitan/account">账户列表</el-menu-item>
								<el-menu-item index="/seller/erp/jushuitan/config">配置列表</el-menu-item>
								<el-menu-item index="/seller/erp/jushuitan/stock">库存同步</el-menu-item>
								<el-menu-item index="/seller/erp/jushuitan/order">订单同步</el-menu-item>
								<el-menu-item index="/seller/erp/jushuitan/orderSend">订单发货</el-menu-item>
								<el-menu-item index="/seller/erp/jushuitan/afterSale">售后列表</el-menu-item>
							</el-submenu>
						</el-menu-item-group>
					</el-submenu>

					<el-submenu index="/seller/warehouse">
						<template slot="title">
							<i class="el-icon-office-building"></i>
							<span>云仓</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/seller/warehouse/index">云仓列表</el-menu-item>
							<el-menu-item index="/seller/warehouse/record">入仓记录</el-menu-item>
							<el-menu-item index="/seller/warehouse/stock">在仓库存</el-menu-item>
							<el-menu-item index="/seller/warehouse/buyout">变现报价</el-menu-item>
							<el-menu-item index="/seller/warehouse/exit">取回记录</el-menu-item>
							<el-menu-item index="/seller/warehouse/settle">结算中心</el-menu-item>
							<el-menu-item index="/seller/warehouse/address">地址簿</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<el-menu-item index="/seller/kuaidizs">
						<i class="el-icon-present"></i>
						<span slot="title">快递助手</span>
					</el-menu-item>
				</el-menu>
				<div class="cksq" @click="collapse = !collapse">
					<i class="el-icon-d-arrow-left" v-if="!collapse"></i>
					<i class="el-icon-d-arrow-right" v-if="collapse"></i>
				</div>
			</div>
			<div class="box">
				<div :class="$route.path.indexOf('home') == -1?'container':'container bg'">
					<router-view :key="rkey"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Seller',
		data() {
			return {
				rkey:new Date().toString(),
				collapse: false
			}
		},
		
		inject: ['appdata'],
		computed: {
			menuActive() {
				if (this.$route.path === '/seller/warehouse/entry') {
					return '/seller/warehouse/index'
				}
				if (this.$route.path === '/seller/warehouse/withdraw') {
					return '/seller/warehouse/settle'
				}
				return this.$route.path
			}
		},

		methods: {
			menuSelect() {
				this.rkey=new Date().toString();
			},
			oncount() {
				this.$refs.header.oncount();
			}
		}
	}
</script>

<style scoped lang="less">
	.main {
		width: 100%;
		min-width: 1200px;
		height: calc(100vh - 121px);
		display: flex;
	}

	.navmenu {
		// width: 170px;
		// min-width: 170px;
		// height: 100%;
		background-color: #fff;
		// overflow: auto;
		position: relative;

		.el-menu {
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;
		}
		
		/deep/ .el-menu-vertical-demo:not(.el-menu--collapse) {
			width: 170px;
			min-width: 170px;
		}
		
		.cksq {
			position: absolute;
			width: 21px;
			height: 60px;
			box-sizing: border-box;
			background-color: #fff;
			top: 50%;
			margin-top: -30px;
			right: -20px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			color: #909399;
			border: 1px solid #EBEEF5;
			border-left: none;
			cursor: pointer;
		}
	}

	.box {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		overflow: hidden;

		.container {
			width: 100%;
			height: 100%;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px 10px 0;
			overflow: auto;
		}

		.bg {
			background-color: #f4f4f4;
			padding: 0px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/seller.vue